import { memo, useState, useEffect } from 'react';
import { Box, Button, CardContent, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography, FormControl, Grid, ToggleButtonGroup, ToggleButton, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from "react";
import { nextStep, update } from '../../../../../slice/multiStepSlice';
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch, useSelector } from "react-redux";
import { z } from "zod";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { useTMutation } from "../../../../../utils/useTMutation";

export const Certification = z.object({
    certificateName: z.string().min(1, { message: "Certificate Name is Required" }),
    requirement: z.string().min(1, { message: "Requirments is Required" }),
});

// export default function AddNewDoc() {

const AddCertification = ({ data }) => {
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    const [toggleValue, setToggleValue] = useState(values.type || 'Basic');

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(Certification),
        defaultValues: { certificateName: values.certificateName || '', requirement: values.required || '' } // Ensure default values
    });

    // Reset form when values change (for edit mode)
    useEffect(() => {
        console.log(values)
        if (values.certificateName || values.required) {
            reset({
                certificateName: values.certificateName || '',
                requirement: values.required || ''
            });
            setToggleValue(values.type || 'Basic');
        }
    }, [values.certificateName, values.required, values.type, reset]);



    const { mutateAsync } = useTMutation("/addCertificate", "post", (response) => {
        console.log('response', response);

        if (response.STATUS) {
            showToast("success", response.MESSAGE, 3000);
            dispatch(update({
                ...values,
                ID: response.OUTPUT?.ID,
                certificateName: response.OUTPUT?.certificateName,
                required: response.OUTPUT?.requirement,
                type: toggleValue,
            }));
            return response;
        }
        else {
            showToast("error", response.MESSAGE, 3000);
        }
    });


    const handleToggleChange = (event, newValue) => {
        if (newValue !== null) {
            setToggleValue(newValue);
        }
    };
    const submitHealthDocuments = async (data) => {
        try {
            data.type = toggleValue;
            if (values.ID) {
                data.ID = values.ID;
            }
            await mutateAsync(data);
            dispatch(nextStep());
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };


    return (


        <Grid lg={12} >
            <CardContent className='gridcardcontent gridtextdata'>
                <Typography variant="h2" component="div" fontWeight="bold" style={{ marginTop: -4 }}>
                  {Object.keys(values).length > 0 ? "Edit" : "Add New"} Certificate
                </Typography>
                <form onSubmit={handleSubmit(submitHealthDocuments)}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <TextField
                            label="Certificate Name"
                            variant="outlined"
                            className='document_name'
                            fullWidth
                            autoFocus={true}
                            margin="normal"
                            // InputProps={{ style: { height: '50px' } }}
                            sx={{
                                '& .MuiOutlinedInput-input': {
                                    padding: 1.94
                                },
                                '& .MuiFormHelperText-root': {
                                    marginLeft: 0,
                                    marginTop: '4px',
                                },
                            }}
                            {...register("certificateName")}
                            error={!!errors.certificateName}
                            helperText={errors.certificateName?.message}
                        />
                        <FormControl fullWidth sx={{ marginTop: 1 }} error={!!errors.requirement}>
                            <InputLabel id="requirement-select-label">Requirement</InputLabel>
                            <Controller
                                name="requirement"
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            labelId="requirement-select-label"
                                            id="requirement-select"
                                            className='document_name'
                                            label="Requirement"
                                            {...field}
                                            error={!!errors.requirement}
                                        >
                                            <MenuItem value="Optional">Optional</MenuItem>
                                            <MenuItem value="Mandatory">Mandatory</MenuItem>
                                        </Select>
                                    </>
                                )}
                            />
                            {errors.requirement && <FormHelperText>{errors.requirement?.message}</FormHelperText>}
                        </FormControl>
                        <Box sx={{ display: "flex", alignItems: "center", marginTop: 2 }}>
                            <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
                                Certificate Type
                            </Typography>
                            <Tooltip title="Basic: Basic certificates with minimal requirements. Specific: Certificates that require additional qualifications.">
                                <IconButton size="small">
                                    <InfoOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "start" }}>
                            <ToggleButtonGroup
                                value={toggleValue}
                                exclusive
                                onChange={handleToggleChange}
                                aria-label="Toggle Type"
                            >
                                <ToggleButton value="Basic" aria-label="Basic">
                                    Basic
                                </ToggleButton>
                                <ToggleButton value="Specific" aria-label="Specific">
                                    Specific
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                            <Button
                                // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
                                className='gradientAdminThemeColor'
                                type='submit'>
                                Next
                            </Button>
                        </Box>
                    </Box>
                </form>
            </CardContent>
        </Grid>
    )
};
export default memo(AddCertification);